import { request } from '@/api/client'

/** GET /developer/activity 的事件类型 */
export const ACTIVITY_EVENT_TYPES = [
  'version_approved',
  'version_rejected',
  'version_released',
  'version_scheduled',
  'scope_opened',
] as const

export type ActivityEventType = (typeof ACTIVITY_EVENT_TYPES)[number]

export interface ListActivityParams {
  page?: number
  page_size?: number
}

/** 一条最近动态。版本类事件带版本号；服务端补齐后还带版本 ID。 */
export interface ActivityRecord {
  app_id: string
  app_name: string
  app_icon?: string
  event_type?: ActivityEventType
  version?: string
  version_id?: string
  platform?: string
  title: string
  detail: string
  created_at: string
}

export interface ListActivityResult {
  list: ActivityRecord[]
  page: number
  page_size: number
  total: number
}

export interface ActivityItemDto {
  app_id?: string
  appId?: string
  app_name?: string
  appName?: string
  app_icon?: string
  appIcon?: string
  event_type?: string
  eventType?: string
  version?: string | null
  version_id?: string | null
  versionId?: string | null
  platform?: string | null
  title?: string
  detail?: string
  created_at?: string
  createdAt?: string
}

interface ActivityDataDto {
  list?: ActivityItemDto[]
  pagination?: {
    page?: number
    page_size?: number
    pageSize?: number
    total?: number
  }
}

export function isActivityEventType(value: string): value is ActivityEventType {
  return (ACTIVITY_EVENT_TYPES as readonly string[]).includes(value)
}

export function mapActivityItem(dto: ActivityItemDto): ActivityRecord {
  const event = dto.event_type ?? dto.eventType ?? ''
  const versionId = dto.version_id ?? dto.versionId
  return {
    app_id: dto.app_id ?? dto.appId ?? '',
    app_name: dto.app_name ?? dto.appName ?? '',
    app_icon: dto.app_icon ?? dto.appIcon ?? undefined,
    event_type: isActivityEventType(event) ? event : undefined,
    version: dto.version ?? undefined,
    version_id: versionId ?? undefined,
    platform: dto.platform ?? undefined,
    title: dto.title ?? '',
    detail: dto.detail ?? '',
    created_at: dto.created_at ?? dto.createdAt ?? '',
  }
}

/** 当前空间的最近动态，按时间倒序。预览 page_size=5，抽屉 page_size=20。 */
export async function listActivity(
  params: ListActivityParams = {},
): Promise<ListActivityResult> {
  const page = params.page ?? 1
  const page_size = params.page_size ?? 20
  const data = await request<ActivityDataDto>('/developer/activity', {
    params: { page, page_size },
  })
  const pagination = data.pagination ?? {}
  return {
    list: (data.list ?? []).map(mapActivityItem),
    page: pagination.page ?? page,
    page_size: pagination.page_size ?? pagination.pageSize ?? page_size,
    total: pagination.total ?? 0,
  }
}
